<template>
  <div class="flex mt-5 justify-center h-screen">
    <h1 class="display-1">Route Not Found *_*</h1>
  </div>
</template>
